module.exports = __webpack_public_path__ + "img/avatar.f213addb.png";